import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconWindowsClose({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M8.882 8.151a.517.517 0 1 0-.73.732L13.268 14 8.15 19.117a.517.517 0 1 0 .731.732L14 14.73l5.117 5.118a.517.517 0 0 0 .732-.732L14.73 14l5.118-5.117a.517.517 0 0 0-.731-.732L14 13.27 8.882 8.151z"/>
        </svg>
    );
}

export default IconWindowsClose;

